import {PaymentCurrencyType} from "@irati/types"
import {useCompanyBudgetsQuery} from "@irati/wallet/hooks/budget"
import tracking from "@irati-tracking/wallet/rewardPointsWallet"
import React from "react"
import Loading from "@irati/ui/src/Loading"
import {Card, Hr} from "@irati/ui/src/Layout"
import Flex from "@irati/ui/src/Flex"
import {H2, H3} from "@irati/ui/src/Typography"
import FormattedMessage, {FormattedCurrency} from "@irati/utils/lang"
import {Tooltip} from "@irati/ui/src/Tooltip"
import Icon, {IconTypes} from "@irati/ui/src/Icon"
import {ButtonRouterLink} from "@irati/ui/src/Link"
import Categories from "../Budget/Categories"
import BudgetBar from "../../Budgeting/BudgetBar"
import IntlMarkdown from "../../styled/IntlMarkdown"

export default function CompanyBudgets() {
  const {data, load} = useCompanyBudgetsQuery()

  return (
    <Card marginTop={2}>
      <Loading load={load}>
        <Flex direction="column" gap={3}>
          <Flex wrap="wrap" gap={3}>
            <Flex direction="column">
              <Flex gap={0.5}>
                <H3>
                  <FormattedMessage id="wallet.reward.intro.walletBalance" />
                </H3>
                <Tooltip
                  tooltipChildren={
                    <IntlMarkdown componentProps={{body: {small: true}}} id="wallet.reward.companyBalance.budgets.tooltip" />
                  }>
                  <Icon icon={IconTypes.circleInformation} large marginLeft={0.5} />
                </Tooltip>
              </Flex>
              <H2 as="span">
                <FormattedCurrency value={data?.total ?? 0} currency={PaymentCurrencyType.Rp} />
              </H2>
            </Flex>

            <Flex gap={2} justifyContent="flex-end" alignItems="flex-start" flex="1 0 fit-content">
              <ButtonRouterLink
                id="rewardWalletTopUpButton"
                to="/flexi-checkout/top-up"
                onClick={() =>
                  tracking.buyPoints({
                    source: "rp_reward_company_wallet_header"
                  })
                }>
                <FormattedMessage id="wallet.reward.budget.rewardWallet.cta.buyPoints" />
              </ButtonRouterLink>
            </Flex>
          </Flex>
          {data && (
            <>
              <BudgetBar {...data.budgets} />
              <Hr flush />
              <Categories height={115} budgets={data.budgets} hideCta />
            </>
          )}
        </Flex>
      </Loading>
    </Card>
  )
}
